import React from 'react';

export default {
  width: 8,
  height: 6,
  content: (
    <>
      <path d="M7 1.00098l-3 3-3-3" />
    </>
  )
};
